import { useEffect, useState } from "react";
import { Form, message } from "antd";
import { SDrawerOrModal, SGeneralForms } from "shj-components";
import { priceStandardRateBatchUpdateDate } from "@/services/product.ts";

const EditTimeModal = (props) => {
  const { open, onClose, onReload, query = {} } = props;
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    form.resetFields()
  }, []);

  const onFinish = () => {
    form.validateFields().then((values => {
      setLoading(true)
      const startDate = values.startDate ? values.startDate.format('YYYY-MM-DD') : undefined;
      let endDate;
      if(props.editType === 'end') {
        endDate = values.endDate ? values.endDate.format('YYYY-MM-DD') : ''
      }
      priceStandardRateBatchUpdateDate({ ...query, startDate, endDate })
        .then(res => {
          message.success(res.message || '操作成功');
          onClose?.()
          onReload?.()
        }).finally(() => setLoading(false))
    }))

  }

  return <>
    <SDrawerOrModal
      title={props.editType === 'start' ? '开始日期' : '结束日期'}
      mode="modal"
      width={500}
      open={open}
      loading={loading}
      onCancel={onClose}
      onOk={onFinish}
    >
      <SGeneralForms
        formConfig={{ form }}
        configs={[{
          formItem: [
            {
              spanCol: 24,
              label: '开始日期',
              name: 'startDate',
              isDeps: true,
              deps: () => props.editType === 'start',
              required: true,
              rules: [{ required: true, message: '开始日期不能为空' }],
              type: 'date',
            },
            {
              spanCol: 24,
              label: '结束日期',
              name: 'endDate',
              isDeps: true,
              deps: () => props.editType === 'end',
              type: 'date',
            },
          ]
        }]}
      />
    </SDrawerOrModal>
  </>
}

export default EditTimeModal